import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogComponent } from 'app/componentes/mat-dialog/mat-dialog.component';
import { ClasificacionProductosService } from 'app/services/productos/clasificacion.service';
import { DataService } from 'app/services/secciones.service';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-clasificacion-detalle',
  templateUrl: './clasificacion-detalle.component.html',
  styleUrls: ['./clasificacion-detalle.component.scss']
})
export class ClasificacionDetalleComponent implements OnInit {

  obtenerId = () => this.activatedRoute.snapshot.params;
  //OBTENEMOS EL ID DE LA SEDE QUE EL USUARIO SELECCIONO 
  idClasificacion: string = this.obtenerId().idClasificacion;

  //VARIABLES
  edit: boolean = false;
  IMAGEN_HOST = environment.API_IMAGEN;
  imagen_icono: any = '';

  //DECLARACIÓN DE FORMULARIOS REACTIVOS 
  ClasificacionForm = new FormGroup({

    clasificacion: new FormControl('', Validators.required),
    estado: new FormControl(1),
    orden: new FormControl(0)

  });

  array: any = [];

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private navigation: DataService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private servicioclasificacion: ClasificacionProductosService,
    ) { }

  ngOnInit(): void {
    if (this.idClasificacion) {
      this.servicioclasificacion.getClasificacionProducto(this.idClasificacion).subscribe(response => {
        this.ClasificacionForm.patchValue(response[0])
      });
    }
  }

  //VERIFICAMOS SI EL USUARIO VA A SALIR DE LA RUTA  CON DATOS EN EL FORMULARIO
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.ClasificacionForm.dirty) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          message: ' ¿ Desea salir sin guardar los cambios ? ',
          buttonText: {
            ok: 'Aceptar',
            cancel: 'Cancelar'
          }
        }
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }

  guardarDatos = () => {

    let datos: any = [];

    this.servicioclasificacion.getClasificacionProductos().subscribe(response => {
      datos = response;
      if (response) {
        this.ClasificacionForm.controls['orden'].setValue(datos.length + 1)
        this.servicioclasificacion.crearClasificacionProducto(this.ClasificacionForm.value).subscribe(response =>{
      
          this.ClasificacionForm.markAsPristine()
          this.ClasificacionForm.markAllAsTouched()
          this.openSnackBar("REGISTRO CREADO CORRECTAMENTE!")
          this.router.navigateByUrl('/clasificaciones')
        });
      }
    })

  }

  actualizarDatos = () => {

    this.servicioclasificacion.actualizarClasificacionProducto(this.idClasificacion, this.ClasificacionForm.value).subscribe(response =>{

      this.ClasificacionForm.markAsPristine()
      this.ClasificacionForm.markAllAsTouched()
      this.openSnackBar("INFORMACIÓN ACTUALIZADA!")
      this.router.navigateByUrl('/clasificaciones')
    });
  }

}
